import { useTranslation } from 'react-i18next';

import { Box } from '@sternum/styled-system';
import { namespaces } from '@sternum/web/services/i18n';

import { List, ListItem, ListItemText, Title } from './Description.styles';

export function Description() {
  const { t } = useTranslation(namespaces.auth);

  const marketingPoints = [
    t('marketingPoint1'),
    t('marketingPoint2'),
    t('marketingPoint3'),
    t('marketingPoint4'),
    t('marketingPoint5'),
    t('marketingPoint6'),
  ];

  return (
    <div>
      <Box mb={24}>
        <Title>{t('authDescriptionTitle')}</Title>
      </Box>

      <List>
        {marketingPoints.map((marketingPoint) => {
          return (
            <ListItem key={marketingPoint}>
              <ListItemText>{marketingPoint}</ListItemText>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
}
